var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c(
            "div",
            {
              staticClass:
                "mb-2 d-flex justify-content-between align-items-start",
            },
            [
              _c("div", [
                _c("h4", { staticClass: "mb-0" }, [
                  _vm._v(
                    _vm._s(
                      _vm.isEditMode
                        ? _vm.model.name || _vm.$t("rental_space.title")
                        : _vm.$t("catalog.space.new_title")
                    )
                  ),
                ]),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("catalog.space.subtitle"))),
                ]),
              ]),
              _vm.spaceId && _vm.model.ticket_enabled
                ? _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "tickets.grid",
                          expression: "'tickets.grid'",
                        },
                      ],
                      attrs: { variant: "outline-primary", size: "sm" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push(
                            "/ingressos/checkin/rental_space/" + _vm.spaceId
                          )
                        },
                      },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "CheckSquareIcon" },
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v(_vm._s(_vm.$t("catalog.ticket.panel"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "wizard-shell",
            {
              attrs: {
                steps: _vm.steps,
                current: _vm.currentStep,
                "done-keys": _vm.doneKeys,
                "free-navigation": _vm.isEditMode,
                busy: _vm.busy,
              },
              on: { prev: _vm.goPrev, next: _vm.goNext, goto: _vm.goToStep },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "sobre",
                      expression: "currentStep === 'sobre'",
                    },
                  ],
                },
                [
                  _c("validation-observer", {
                    ref: "validator",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var valid = ref.valid
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "vx-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-7/12 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("rental_space.name"),
                                          rules: "required",
                                          mode: "lazy",
                                          slim: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (validationContext) {
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label:
                                                          _vm.$t(
                                                            "rental_space.name"
                                                          ),
                                                        "label-for": "name",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        staticClass: "required",
                                                        attrs: {
                                                          id: "name",
                                                          type: "text",
                                                          placeholder: _vm.$t(
                                                            "catalog.space.name_placeholder"
                                                          ),
                                                          state:
                                                            _vm.getValidationState(
                                                              validationContext
                                                            ),
                                                        },
                                                        model: {
                                                          value: _vm.model.name,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model,
                                                              "name",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.name",
                                                        },
                                                      }),
                                                      _c(
                                                        "b-form-invalid-feedback",
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              validationContext
                                                                .errors[0]
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-5/12 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("rental_space.category"),
                                          rules: "required",
                                          slim: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (validationContext) {
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "rental_space.category"
                                                        ),
                                                        "label-for":
                                                          "category_id",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-select",
                                                        {
                                                          staticClass:
                                                            "required-select",
                                                          attrs: {
                                                            id: "category_id",
                                                            options:
                                                              _vm.categories,
                                                            label: "name",
                                                            required: true,
                                                          },
                                                          model: {
                                                            value: _vm.category,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.category = $$v
                                                            },
                                                            expression:
                                                              "category",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                slot: "no-options",
                                                              },
                                                              slot: "no-options",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Nenhum registro encontrado!"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              validationContext
                                                                .errors[0]
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Estabelecimento",
                                    rules: "required",
                                    slim: "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (validationContext) {
                                          return [
                                            _c("select-suggestion", {
                                              attrs: {
                                                id: "legal_entity_id",
                                                column:
                                                  "company_name,trading_name,cnpj",
                                                model: "LegalEntity",
                                                label:
                                                  _vm.$t("responsible_entity"),
                                                appendClearOption: true,
                                                placeholderText:
                                                  "Digite o nome do estabelecimento",
                                                itemTextFormat:
                                                  _vm.legalEntityItemTextFormat,
                                                required: true,
                                              },
                                              model: {
                                                value: _vm.legalEntity,
                                                callback: function ($$v) {
                                                  _vm.legalEntity = $$v
                                                },
                                                expression: "legalEntity",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    validationContext.errors[0]
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _c("validation-provider", {
                                  attrs: {
                                    name: _vm.$t("rental_space.description"),
                                    rules: "max:500",
                                    slim: "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (validationContext) {
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                staticClass: "mt-1",
                                                attrs: {
                                                  label: _vm.$t(
                                                    "rental_space.description"
                                                  ),
                                                  "label-for": "description",
                                                },
                                              },
                                              [
                                                _c("b-form-textarea", {
                                                  attrs: {
                                                    id: "description",
                                                    rows: "3",
                                                    "max-rows": "6",
                                                    state:
                                                      _vm.getValidationState(
                                                        validationContext
                                                      ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model.description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.description",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-muted d-block",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "catalog.space.description_hint"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c("b-form-invalid-feedback", [
                                                  _vm._v(
                                                    _vm._s(
                                                      validationContext
                                                        .errors[0]
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _c("hr", { staticClass: "my-2" }),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            attrs: { switch: "" },
                                            model: {
                                              value: _vm.model.ticket_enabled,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "ticket_enabled",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.ticket_enabled",
                                            },
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "catalog.ticket.enable"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "small",
                                          { staticClass: "text-muted d-block" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "catalog.ticket.enable_hint"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.model.ticket_enabled
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mt-2",
                                            attrs: { cols: "12" },
                                          },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "catalog.ticket.type"
                                                  ),
                                                },
                                              },
                                              [
                                                _c("choice-cards", {
                                                  attrs: {
                                                    options:
                                                      _vm.ticketTypeCards,
                                                    value:
                                                      _vm.model.ticket_type,
                                                  },
                                                  on: {
                                                    input: function (value) {
                                                      _vm.model.ticket_type =
                                                        value
                                                    },
                                                  },
                                                }),
                                                !_vm.model.ticket_type
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-warning d-block mt-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "catalog.ticket.type_required"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                !valid
                                  ? _c("div", { staticClass: "mt-1" }, [
                                      _c(
                                        "small",
                                        { staticClass: "text-warning" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "catalog.wizard.fill_required"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "horarios",
                      expression: "currentStep === 'horarios'",
                    },
                  ],
                },
                [
                  _vm.spaceId
                    ? [
                        _c(
                          "small",
                          { staticClass: "text-muted d-block mb-1" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("catalog.space.schedule_hint"))
                            ),
                          ]
                        ),
                        _c("schedule-manager", {
                          attrs: { readonly: false },
                          on: {
                            change: _vm.onScheduleChange,
                            "validity-change": _vm.onScheduleValidityChange,
                          },
                          model: {
                            value: _vm.scheduleData,
                            callback: function ($$v) {
                              _vm.scheduleData = $$v
                            },
                            expression: "scheduleData",
                          },
                        }),
                        _vm.scheduleDirty && _vm.scheduleValid
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "flex justify-end items-center gap-2 mt-2",
                              },
                              [
                                _c("span", { staticClass: "text-warning" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("schedule.space.unsaved"))
                                  ),
                                ]),
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary", size: "sm" },
                                    on: { click: _vm.saveSchedule },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("catalog.space.save_schedule")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "venda",
                      expression: "currentStep === 'venda'",
                    },
                  ],
                },
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "p-1 mb-2",
                      attrs: {
                        show: _vm.productLoadFailed,
                        variant: "warning",
                      },
                    },
                    [
                      _c("small", [
                        _vm._v(_vm._s(_vm.$t("catalog.sale.sale_unavailable"))),
                      ]),
                    ]
                  ),
                  _vm.productExists
                    ? _c(
                        "sale-step",
                        {
                          attrs: {
                            "product-id": _vm.product.id,
                            price: _vm.product.price,
                            description: _vm.product.description,
                            "how-works": _vm.product.how_works,
                            guidelines: _vm.product.guidelines,
                            files: _vm.productFiles,
                            "multi-sale": _vm.productMultiSale,
                            "show-photos": false,
                            "price-hint": _vm.$t("catalog.space.price_hint"),
                          },
                          on: {
                            "update:price": function ($event) {
                              return _vm.$set(_vm.product, "price", $event)
                            },
                            "update:description": function ($event) {
                              return _vm.$set(
                                _vm.product,
                                "description",
                                $event
                              )
                            },
                            "update:howWorks": function ($event) {
                              return _vm.$set(_vm.product, "how_works", $event)
                            },
                            "update:how-works": function ($event) {
                              return _vm.$set(_vm.product, "how_works", $event)
                            },
                            "update:guidelines": function ($event) {
                              return _vm.$set(_vm.product, "guidelines", $event)
                            },
                            "file-uploaded": _vm.onProductFileUploaded,
                            "delete-file": _vm.deleteProductFile,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "sale-step-extra" },
                            [
                              _c(
                                "h6",
                                { staticClass: "mb-50" },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: {
                                      icon: "ImageIcon",
                                      svgClasses: "w-4 h-4",
                                    },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("catalog.space.logo_title")
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                              _c("image-upload", {
                                key: _vm.logoUploadURL,
                                staticClass:
                                  "border-faint-grey border-solid border p-2 rounded-lg inline-block",
                                attrs: {
                                  maxHeight: "120px",
                                  maxWidth: "240px",
                                  hint: _vm.$t("catalog.space.logo_hint"),
                                  uploadUrl: _vm.logoUploadURL,
                                },
                                on: {
                                  "upload-complete": _vm.uploadLogoSuccess,
                                },
                                model: {
                                  value: _vm.imageData,
                                  callback: function ($$v) {
                                    _vm.imageData = $$v
                                  },
                                  expression: "imageData",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "revisar",
                      expression: "currentStep === 'revisar'",
                    },
                  ],
                },
                [
                  _c("review-step", {
                    attrs: {
                      summary: _vm.reviewSummary,
                      price: _vm.product.price,
                      "price-suffix": _vm.$t("catalog.space.price_suffix"),
                      published: _vm.productPublished,
                      blockers: _vm.publishBlockers,
                      "front-url": _vm.publishedFrontUrl,
                      busy: _vm.busy,
                      "price-step-key": "venda",
                    },
                    on: {
                      goto: _vm.goToStep,
                      publish: _vm.publish,
                      "save-draft": _vm.saveDraft,
                      unpublish: _vm.unpublish,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }